module.exports = __webpack_public_path__ + "static/media/alfa_romeo_logo.0fa92f04.png";